import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { TrendingUp, Users, LayoutGrid, LayoutPanelTop, Calendar as CalendarIcon } from 'lucide-react';

const TABS = [
  { key: 'overview', label: 'Overview', icon: TrendingUp },
  { key: 'consultants', label: 'Consultores', icon: Users, adminOnly: true },
  { key: 'occupation', label: 'Ocupação', icon: LayoutGrid, adminOnly: true },
  { key: 'blocks', label: 'Blocos', icon: LayoutPanelTop, adminOnly: true },
  { key: 'monthly', label: 'Mensal', icon: CalendarIcon, adminOnly: true },
];

/**
 * Shared secondary navigation rendered on both Home and Analytics pages.
 * - "Início" links to /home
 * - The other tabs link to /analytics?tab=<key>
 * - Active state is computed from the URL (pathname + ?tab=)
 */
export default function SecondaryNav({ user, className = '' }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = (user?.role || '').toUpperCase() === 'ADMIN';
  const tabs = TABS.filter((t) => !t.adminOnly || isAdmin);

  const isHome = location.pathname === '/' || location.pathname === '/home';
  const params = new URLSearchParams(location.search);
  const currentTab = params.get('tab') || 'overview';
  const isAnalytics = location.pathname.startsWith('/analytics');

  const itemCls = (active) =>
    `flex items-center gap-2 px-3 py-2 text-sm transition-colors border-b-2 ${
      active
        ? 'border-emerald-700 text-emerald-700 font-medium'
        : 'border-transparent text-gray-500 hover:text-gray-700'
    }`;

  return (
    <div className={`flex items-center gap-1 border-t border-gray-100 -mb-px px-6 pt-3 overflow-x-auto ${className}`}>
      <button
        onClick={() => navigate('/home')}
        className={itemCls(isHome)}
        data-testid="home-tab-button"
      >
        Início
      </button>
      {tabs.map((t) => {
        const Icon = t.icon;
        const active = isAnalytics && currentTab === t.key;
        return (
          <button
            key={t.key}
            onClick={() => navigate(`/analytics?tab=${t.key}`)}
            className={itemCls(active)}
            data-testid={`home-tab-${t.key}`}
          >
            <Icon className="w-4 h-4" />
            <span>{t.label}</span>
          </button>
        );
      })}
    </div>
  );
}
